import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { OperatorSectionPageView } from './OperatorSectionPageView';

const SECTION_BY_PATH: Record<string, string> = {
  '/operator/compliance': 'operatorCompliance',
  '/operator/reports': 'operatorReports',
};

export function OperatorSectionPageContainer() {
  const { pathname } = useLocation();
  const { t } = useTranslation('navigation');
  const { t: tDashboard } = useTranslation('dashboard');

  const sectionKey = useMemo(() => {
    const match = Object.entries(SECTION_BY_PATH).find(([path]) =>
      pathname.startsWith(path),
    );
    return match?.[1] ?? 'operator';
  }, [pathname]);

  return (
    <OperatorSectionPageView
      title={t(sectionKey)}
      description={tDashboard('operator.placeholder')}
    />
  );
}
